<script lang="ts">
	import Tag from '$lib/elements/tags/Tag.svelte';
	import type { TagProps } from '$lib/elements/tags/types.js';

	export let props: TagProps;
	$: props = { ...props, classNames: `${props.classNames ?? ''} bg-secondary text-white` };
</script>

<Tag {props}>
	<slot />
</Tag>
